import React, { type PropsWithChildren } from 'react';
import {
  type ComponentProps,
  type EmbeddedReportElement,
} from '@aha-app/aha-editor-v2';
import styles from './EmbeddedReport.module.css';

interface BlockedReportComponentProps
  extends ComponentProps<EmbeddedReportElement> {}

const BlockedReportComponent: React.FC<
  PropsWithChildren<BlockedReportComponentProps>
> = ({ attributes, element, children }) => {
  const width = element.resizer_width || 900;
  const height = element.resizer_height || 500;
  const style = {
    width,
    height,
  };

  return (
    <div
      {...attributes}
      className={styles.BlockedReport}
      style={style}
      contentEditable={false}
    >
      <span className='text-muted'>
        This report cannot be viewed inside a shared document
      </span>
      {children}
    </div>
  );
};

export default BlockedReportComponent;
